import { ProductSliderPlaceholder } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const StyledListPlaceholder = styled(ProductSliderPlaceholder)<{
  containerProps: Record<string, string>;
  center?: boolean;
}>`
  overflow-x: auto;
  margin: 1.5rem 0 4rem;

  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
`;

export const StyledCardPlaceholderList = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  overflow-x: auto;
  margin: 1.5rem 0 4rem;
`;

export const StyledCardPlaceholderItem = styled.div`
  flex: 1 1 0;
  min-width: 0;

  & > * {
    width: 100%;
  }
`;
